import React from 'react'
import './TodoItem.scss'
import { useState } from 'react'
import { database } from '../../../firebaseConfig'

export const TodoItem = props => {

    const [isCompleted] = useState(props.isCompleted)

    const classes = [
        "todoItem__left__text",
    ]

    if (isCompleted) classes.push('checked')

    const clickHandler = () => {
        database.collection(props.uid).doc(props.id).update({
            isCompleted: !isCompleted
        })

    }


    return (
        <div className='todoItem'>
            <div className="todoItem__left" >
                <div className="todoItem__left__number">{props.number} &nbsp;&nbsp;&nbsp;</div>
                <div className="todoItem__left__check"><input type="checkbox" onChange={clickHandler} checked={isCompleted} /> </div>
                <div className={classes.join(' ')}>{props.text}</div>
            </div>

            <div className="todoItem__right">
                <button onClick={props.deleteHandler}>&#128465;</button>
                <div className='todoItem__right__date'>{props.date}</div>
            </div>

        </div>
    )
}